type ParticipantSurveyPhase = "pre" | "post";

type ParticipantSurveyChangeHandler = (value: number) => void;

export type ParticipantSurveyItem = {
  id: "pain" | "energy" | "positivity";
  label: string;
  sub: string;
  lowLabel: string;
  highLabel: string;
  value: number;
  onChange: ParticipantSurveyChangeHandler;
};

type BuildParticipantSurveyItemsOptions = {
  phase: ParticipantSurveyPhase;
  pain: number;
  energy: number;
  positivity: number;
  onPainChange: ParticipantSurveyChangeHandler;
  onEnergyChange: ParticipantSurveyChangeHandler;
  onPositivityChange: ParticipantSurveyChangeHandler;
};

export function buildParticipantSurveyItems({
  phase,
  pain,
  energy,
  positivity,
  onPainChange,
  onEnergyChange,
  onPositivityChange,
}: BuildParticipantSurveyItemsOptions): ParticipantSurveyItem[] {
  if (phase === "post") {
    return [
      {
        id: "pain",
        label: "How much pain are you experiencing now? (1–10)",
        sub: "1 = no pain · 10 = worst pain imaginable",
        lowLabel: "No pain",
        highLabel: "Worst pain",
        value: pain,
        onChange: onPainChange,
      },
      {
        id: "energy",
        label: "How much energy do you have now? (1–10)",
        sub: "1 = extremely tired · 10 = extremely energized",
        lowLabel: "Tired",
        highLabel: "Energized",
        value: energy,
        onChange: onEnergyChange,
      },
      {
        id: "positivity",
        label: "How positive or negative do you feel now?",
        sub: "1 = very negative · 10 = very positive",
        lowLabel: "Negative",
        highLabel: "Positive",
        value: positivity,
        onChange: onPositivityChange,
      },
    ];
  }

  return [
    {
      id: "pain",
      label: "Pain level (1–10)",
      sub: "1 = no pain · 10 = worst pain imaginable",
      lowLabel: "No pain",
      highLabel: "Worst pain",
      value: pain,
      onChange: onPainChange,
    },
    {
      id: "energy",
      label: "Energy level (1–10)",
      sub: "1 = extremely tired · 10 = extremely energized",
      lowLabel: "Tired",
      highLabel: "Energized",
      value: energy,
      onChange: onEnergyChange,
    },
    {
      id: "positivity",
      label: "Mood positivity (1–10)",
      sub: "1 = very negative · 10 = very positive",
      lowLabel: "Negative",
      highLabel: "Positive",
      value: positivity,
      onChange: onPositivityChange,
    },
  ];
}
